import { Component } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import PostEditor from '@insided/shared/uikit/PostEditor'
import { ContentType } from '@insided/shared/utils/contentType'
import classNames from 'classnames'
import { PageUnloadContext } from '@insided/shared/services/PageUnloadContext'

export interface TopicAddReplyProps {
  topicId: number
  isGuest: boolean
  type: ContentType
}

export interface TopicAddReplyState {
  content: string
}

class TopicAddReply extends Component<TopicAddReplyProps, TopicAddReplyState> {
  constructor (props: TopicAddReplyProps) {
    super(props)
    this.state = {
      content: ''
    }
    this.onChange = this.onChange.bind(this)
  }

  onChange (content: string) {
    this.setState({ content })
  }

  render () {
    const { topicId, isGuest, type } = this.props
    const { content } = this.state
    return (
      <PageUnloadContext.Consumer>
        {({ lock, unlock }) => {
          return (
            <div className={classNames('box__content', 'qa-reply', 'reply-editor-wrapper')}>
              <h3>
                <Phrase p='editor.title.comment' />
              </h3>
              <br />
              <PostEditor
                type={type}
                disableFileAttachments={false}
                topicId={topicId}
                replyId={null}
                isControl={false}
                onSuccess={() => {
                  unlock()
                  window.location.reload()
                }}
                redirect={false}
                isGuest={isGuest}
                onChange={(content) => {
                  lock(content)
                  this.onChange(content)
                }}
                data={content}
              />
            </div>
          )
        }}
      </PageUnloadContext.Consumer>
    )
  }
}

export default TopicAddReply
